import { api } from "@/lib/api";
import type { ActivityEntry } from "@/services/activity.service";

export interface TaskChange {
	field: string;
	from?: unknown;
	to?: unknown;
	from_name?: string | null;
	to_name?: string | null;
	edited?: boolean;
	was_empty?: boolean;
	is_now_empty?: boolean;
}

export interface TaskHistoryList {
	count: number;
	page: number;
	limit: number;
	totalPages: number;
	data: ActivityEntry[];
}

export interface GetTaskHistoryParams {
	page?: number;
	limit?: number;
	action?: string;
}

export async function getTaskHistory(
	projectId: string,
	taskId: string,
	params: GetTaskHistoryParams = {},
): Promise<TaskHistoryList> {
	const query = new URLSearchParams();
	if (params.page) query.set("page", String(params.page));
	if (params.limit) query.set("limit", String(params.limit));
	if (params.action) query.set("action", params.action);

	const qs = query.toString();
	const res = await api.get<{ success: boolean } & TaskHistoryList>(
		`/projects/${projectId}/tasks/${taskId}/history${qs ? `?${qs}` : ""}`,
	);

	return {
		count: res.count ?? 0,
		page: res.page ?? 1,
		limit: res.limit ?? params.limit ?? 50,
		totalPages: res.totalPages ?? 1,
		data: res.data ?? [],
	};
}
